<mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="isPersonalLoan != null">
  <mat-card-header>
    <mat-card-title>Borrower type</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select borrower type and number of borrowers</mat-label>
          <mat-select placeholder="Select borrower type and number of borrowers" formControlName="borrowerType" (selectionChange)="updateIndividualCount($event.value)">
            <mat-option *ngFor="let type of borrowingTypes" [value]="type.id">{{type.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'borrowerType'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline" *ngIf="borrowerCountRequired">
          <mat-label>{{countLabel}}</mat-label>
          <mat-select placeholder="{{countLabel}}" formControlName="borrowerCount">
            <mat-option [value]="1" *ngIf="formGroup.get('borrowerType').value !== 'joint-individual'">1</mat-option>
            <mat-option [value]="2">2</mat-option>
            <mat-option [value]="3">3</mat-option>
            <mat-option [value]="4">4</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'borrowerCount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="showTrustACN">
      <div class="col-sm-8">
        <fmc-abn-search
            [parentFormGroup]="formGroup"
            [controlName]="'trustACN'"
            [placeholderText]="'ACN search'"
            (abnResults)="selectTrustACN($event)"
        ></fmc-abn-search>
      </div>
    </div>
  </mat-card-content>
</mat-card>
